export const female_hands = [ //An array of each Female Hand's ID and Name. There are 2.
  {
    id: 'hand10',
    name: 'Open hands'
  },
  {
    id: 'hand12',
    name: 'Closed hands'
  },
]